export default [
  {
    path: '/reset-password',
    name: 'reset-password',
    component: () => import(/* webpackChunkName: 'PageResetPassword' */ '../PageResetPassword'),
  },
];
